import { Avatar, Typography } from '@sanlam-glacier/app-common/components';
import { VerticalDivider } from '../vertical-divider/VerticalDivider';
import styles from './app-bar-avatar.module.scss';
import { useAuth } from 'auth';

export const AppBarAvatar = () => {
  const authApi = useAuth();
  const currentSignedInUser = authApi.getSignedInUser();
  const getLoggedInUserName = (): string => currentSignedInUser?.displayName ?? '';
  const initials = (): string =>
    `${currentSignedInUser?.fullName?.[0] ?? ''} ${currentSignedInUser?.familyName?.[0] ?? ''}`;
  return (
    <>
      <div className={styles.avatarContainer}>
        <Typography color={Typography.COLOR.INHERIT} className={styles.userInfo}>
          {getLoggedInUserName()}
        </Typography>
        <VerticalDivider />
        <Avatar>{initials()}</Avatar>
      </div>
    </>
  );
};
